module.exports = __webpack_public_path__ + "static/media/cof_init.2073aa7d.png";